import { ProductCode, ProductFamilyCode } from '../types';

const NON_SELF_SERVE_PRODUCT_CODES = new Set([
  ProductCode.CTS_BST,
  ProductCode.MPT_MPT,
  ProductCode.VRA_PRO,
  ProductCode.CPS_CUS,
  ProductCode.CAI_BSC,
  ProductCode.CAI_ADV,
  ProductCode.TTE_SLF,
  ProductCode.TTE_ISO,
  ProductCode.TTE_RFN,
  ProductCode.TTE_IPF,
]);

const NON_SELF_SERVE_PRODUCT_FAMILY_CODES = new Set([
  ProductFamilyCode.CTS,
  ProductFamilyCode.MPT,
  ProductFamilyCode.VRA,
  ProductFamilyCode.CAI,
  ProductFamilyCode.TTE,
]);

export const isNonSelfServeProductCode = (
  productCode: ProductCode
): boolean => {
  return NON_SELF_SERVE_PRODUCT_CODES.has(productCode);
};

export const isNonSelfServeProductFamilyCode = (
  productFamilyCode: ProductFamilyCode
): boolean => {
  return NON_SELF_SERVE_PRODUCT_FAMILY_CODES.has(productFamilyCode);
};
